export const FAIR_PAY_MENU_ITEMS = [
  { title: "Pay Plans", count: null },
  { title: "Positions", count: null },
  { title: "Pay Ranges", count: null },
  { title: "Job Families", count: null },
  { title: "Job Categories", count: null },
  { title: "Market Data", count: null },
];

export const FAIR_PAY_TAB = {
  PAY_PLANS: 0,
  POSITION_PAY_RANGES: 1,
  PAY_RANGES: 2,
  JOB_FAMILIES: 3,
  JOB_CATEGORIES: 4,
  MARKET_DATA: 5,
};

/** In-page tabs carried in the list URL as `?tab=<slug>` (rule N1). */
export const FAIR_PAY_TAB_SLUG = {
  [FAIR_PAY_TAB.PAY_PLANS]: "pay-plans",
  [FAIR_PAY_TAB.POSITION_PAY_RANGES]: "positions",
  [FAIR_PAY_TAB.PAY_RANGES]: "pay-ranges",
  [FAIR_PAY_TAB.MARKET_DATA]: "market-data",
};

const LEGACY_NUMERIC_TABS = [
  FAIR_PAY_TAB.PAY_PLANS,
  FAIR_PAY_TAB.POSITION_PAY_RANGES,
  FAIR_PAY_TAB.PAY_RANGES,
  FAIR_PAY_TAB.MARKET_DATA,
];

/**
 * Resolve a `?tab=` value (slug, or legacy numeric 0/1/2/5) to a tab index.
 * Returns null for an unknown value.
 */
export function fairPayTabFromQuery(value) {
  const raw = Array.isArray(value) ? value[0] : value;
  if (raw === undefined || raw === null) return null;
  const text = String(raw).trim();
  const bySlug = Object.keys(FAIR_PAY_TAB_SLUG).find((tab) => FAIR_PAY_TAB_SLUG[tab] === text);
  if (bySlug !== undefined) return Number(bySlug);
  if (/^\d+$/.test(text) && LEGACY_NUMERIC_TABS.includes(Number(text))) return Number(text);
  return null;
}

export function fairPayListRoute(tab, context = {}) {
  return { name: "FairPay", query: { tab: FAIR_PAY_TAB_SLUG[tab] ?? tab, ...context } };
}

/**
 * Bind envelope badge counts onto Pay Plans / Pay Ranges only.
 * Every other tab stays count: null (ER-10862).
 */
export function buildFairPayMenuItems({
  currentPayPlanCount = null,
  activePayRangeCount = null,
} = {}) {
  return FAIR_PAY_MENU_ITEMS.map((item, index) => {
    if (index === FAIR_PAY_TAB.PAY_PLANS) {
      return { ...item, count: currentPayPlanCount };
    }
    if (index === FAIR_PAY_TAB.PAY_RANGES) {
      return { ...item, count: activePayRangeCount };
    }
    return { ...item, count: null };
  });
}
